import T from 'i18n-react'
import {
  MODULES
} from 'containers/Project/Specifications/constants'

const MODULE_NAME = 'fulcrum/containers/Project/View'
const UPDATE_PROJECT_INFO = 'fulcrum/containers/Project/View/UPDATE_PROJECT_INFO'
const UPDATE_PROJECT_WORKFLOW = 'fulcrum/containers/Project/View/UPDATE_PROJECT_WORKFLOW'
const CLEAR_PROJECT_INFO = 'fulcrum/containers/Project/View/CLEAR_PROJECT_INFO'
const LOAD_FORM_DATA = 'fulcrum/containers/Project/View/LOAD_FORM_DATA'
const TOGGLE_COLLAPSE = 'fulcrum/containers/Project/View/TOGGLE_COLLAPSE'
const CLONE_PROJECT = 'fulcrum/containers/Project/View/CLONE_PROJECT'
const POST_CANCEL_PROJECT = 'fulcrum/containers/Project/View/POST_CANCEL_PROJECT'
const POST_CANCEL_PROJECT_START = 'fulcrum/containers/Project/View/POST_CANCEL_PROJECT_START'
const POST_CANCEL_PROJECT_SUCCESS = 'fulcrum/containers/Project/View/CLONE_PROJECT/POST_CANCEL_PROJECT_SUCCESS'
const POST_CANCEL_PROJECT_ERROR = 'fulcrum/containers/Project/View/CLONE_PROJECT/POST_CANCEL_PROJECT_ERROR'
const SCROLL_TOP = 'fulcrum/containers/Project/View/SCROLL_TOP'








const NAVIGATION_CATEGORY = Object.freeze([
  { key: 'specifications', label: 'Specifications' },
  { key: 'project_schedule', label: 'Schedule' },
  { key: 'project_execution', label: 'Project Execution' },
  { key: 'lifecycle', label: 'Lifecycle' },
  { key: 'weekly_updates', label: 'Weekly Updates' },
  { key: 'nvbugs', label: 'NVBugs' },
  { key: 'nvqual_report', label: 'NVQual Report',
    list: [
      { key: 'summary', label: 'Summary' },
      { key: 'thermal_qual_test', label: 'Thermal Test GPU' },
      { key: 'thermal_qual_test_cpu', label: 'Thermal Test CPU' },
      { key: 'bluefield_thermal_test', label: 'Thermal Test Bluefield' },
      { key: 'pcie_qual_test', label: 'PCIe Qual Test' },
      { key: 'pcie_bandwidth_test', label: 'PCIe B/W Test' },
      { key: 'pcie_peer_to_peer_test', label: 'PCIe GPU Peer to Peer B/W Test' },
      { key: 'input_edp_test', label: 'Input EDP Test' },
      { key: 'nvlink_bandwidth_test', label: 'NVLink B/W Test' },
      { key: 'nvlink_qual_test', label: 'NVLink Qual Test' },
      { key: 'nvlink_data_eye_test', label: 'NVLink Data Eye Metric' },
      { key: 'pcie_data_eye_test', label: 'PCIe Data Eye Metric' },
      { key: 'cpu_nvlink_qualification_test', label: 'CPU NVLink Qualification Test' },
      { key: 'gpu_nvlink_qualification_test', label: 'GPU NVLink Qualification Test' },
      { key: 'cx7_pcie_test', label: 'ConnectX-7 PCIE Qualification Test' },
      { key: 'grace_rx_pcie_eom_test', label: 'Grace RX PCIE EOM Test' },
      { key: 'ssd_fio_test', label: 'SSD FIO Test' },
      { key: 'bluefield_eye_margin_test', label: 'Bluefield-3 Eye Margin Test' },
      { key: 'bluefield_thermal_test', label: 'Bluefield-3 Thermal Test' },
      { key: 'bluefield_pcie_interface_traffic_test', label: 'Bluefield-3 PCIE Interface Traffic Test' },
      { key: 'cx7_thermal_test', label: 'ConnectX-7 Thermal Test' },
      { key: 'secondary_bus_reset_test', label: 'Secondary Bus Reset Test' },
      { key: 'equalization_test', label: 'Equalization Test' },
      { key: 'disable_and_enable_link_test', label: 'Disable and Enable Link Test' },
      { key: 'pcie_link_retrain_test', label: 'PCIE Link Retrain Test' },
      { key: 'aer_error_check_test', label: 'AER Error Check Test' },
      { key: 'speed_change_test', label: 'Speed Change Test' },
      { key: 'l1_power_management_test', label: 'L1 Power Management Test' },
      { key: 'd3_power_management_test', label: 'D3 Power Management Test' },
      { key: 'cpu_qualification_test', label: 'CPU Qualification Test' },
      { key: 'memory_qualification_test', label: 'Memory Qualification Test' }
    ]
  },
  { key: 'customer_program_management', label: 'Customer Program Management' },
  { key: 'support_team', label: 'Support Team' },
  { key: 'attachments', label: 'Attachments' },
  { key: 'green_light_report', label: 'Green Light Report' },

])

export {
  MODULE_NAME,
  NAVIGATION_CATEGORY,
  UPDATE_PROJECT_INFO,
  UPDATE_PROJECT_WORKFLOW,
  CLEAR_PROJECT_INFO,
  LOAD_FORM_DATA,
  TOGGLE_COLLAPSE,
  CLONE_PROJECT,
  POST_CANCEL_PROJECT,
  POST_CANCEL_PROJECT_START,
  POST_CANCEL_PROJECT_SUCCESS,
  POST_CANCEL_PROJECT_ERROR,
  SCROLL_TOP
}
